import { useMutation } from '@tanstack/react-query'
import { UseBaseMutationOptions } from '@/core/api/type'

import { settingsService } from '../services'

const useMutationDeleteFlexHotGame = (
	baseQueryOptions?: UseBaseMutationOptions<unknown, string>,
) => {
	return useMutation({
		mutationFn: (id: string) => settingsService.deleteFlexHotGame(id),
		...baseQueryOptions,
	})
}

export default useMutationDeleteFlexHotGame
